import { Component, Input } from "@angular/core"

@Component({
    selector: "app-element-placeholder",
    templateUrl: "./element-placeholder.component.html",
    styleUrls: ["./element-placeholder.component.scss"],
})
export class ElementPlaceholder {
    @Input() public type: string = "large" // large, inline

    public getLoaderType() {
        return { [this.type]: true }
    }
}
